import * as React from 'react';
import { Input, InputWrapperWidget } from './inputs';
import { useField } from 'formik';
import { MAX_INPUT_FIELD_LENGTH } from '../../utils/Validators';

export interface InputFieldWidgetProps {
  label?: string;
  name: string;
  error?: string | false | null;
  className?: any;
  input?: React.InputHTMLAttributes<HTMLInputElement>;
  disabled?: boolean;
  onChange?: (value: string | null) => any;
}

export const FormikInputWidget: React.FC<InputFieldWidgetProps> = (props) => {
  const [field, meta] = useField(props.name);
  const error = meta.touched && (props.error || meta.error);

  return (
    <InputWrapperWidget className={props.className} label={props.label} error={error}>
      <Input
        {...field}
        {...(props.input || {})}
        maxLength={MAX_INPUT_FIELD_LENGTH}
        error={!!error}
        disabled={props.disabled}
        onChange={(event) => {
          field.onChange(event);
          let value: string | null = event.target.value;
          if (value.trim() === '') {
            value = null;
          }
          props.onChange?.(value);
        }}
      />
    </InputWrapperWidget>
  );
};
